require('./jquery.scrollbar');
module.exports = 'jQueryScrollbar';




//////////////////
// WEBPACK FOOTER
// ./~/jquery.scrollbar/index.js
// module id = 36
// module chunks = 0